import React from 'react';
import { FormField, ImageOptions } from '../../types/form';

interface FieldPreviewProps {
  field: FormField;
}

export const FieldPreview: React.FC<FieldPreviewProps> = ({ field }) => {
  if (field.field_type === 'image') {
    const imageOptions = (field.options || {}) as ImageOptions;
    
    if (imageOptions.imageUrl || imageOptions.imageFile || imageOptions.imageUrl2 || imageOptions.imageFile2) {
      return (
        <div className="space-y-2">
          {imageOptions.layout === 'side-by-side' ? (
            <div className="flex gap-2">
              {(imageOptions.imageUrl || imageOptions.imageFile) && (
                <img 
                  src={imageOptions.imageFile || imageOptions.imageUrl} 
                  alt={imageOptions.imageAlt || 'Left image'}
                  className="flex-1 h-auto rounded border object-cover"
                  style={{ maxHeight: '150px' }}
                  onError={(e) => {
                    const img = e.target as HTMLImageElement;
                    img.style.display = 'none';
                  }}
                />
              )}
              {(imageOptions.imageUrl2 || imageOptions.imageFile2) && (
                <img 
                  src={imageOptions.imageFile2 || imageOptions.imageUrl2} 
                  alt={imageOptions.imageAlt2 || 'Right image'}
                  className="flex-1 h-auto rounded border object-cover"
                  style={{ maxHeight: '150px' }}
                  onError={(e) => {
                    const img = e.target as HTMLImageElement;
                    img.style.display = 'none';
                  }}
                />
              )}
            </div>
          ) : (imageOptions.imageUrl || imageOptions.imageFile) && (
            <img 
              src={imageOptions.imageFile || imageOptions.imageUrl} 
              alt={imageOptions.imageAlt || 'Form image'}
              className="max-w-full h-auto rounded border"
              style={{ maxHeight: '150px' }}
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.style.display = 'none';
              }}
            />
          )}
          <div className="text-xs space-y-1">
            <div>Layout: {imageOptions.layout || 'single'}</div>
            <div>Size: {imageOptions.imageSize || 'medium'}</div>
            {imageOptions.imageSource === 'url' && imageOptions.imageUrl && <div>Left/Main: {imageOptions.imageUrl}</div>}
            {imageOptions.imageSource === 'file' && imageOptions.imageFileName && <div>Left/Main: {imageOptions.imageFileName}</div>}
            {imageOptions.imageSource2 === 'url' && imageOptions.imageUrl2 && <div>Right: {imageOptions.imageUrl2}</div>}
            {imageOptions.imageSource2 === 'file' && imageOptions.imageFileName2 && <div>Right: {imageOptions.imageFileName2}</div>}
          </div>
        </div>
      );
    }
    return <div className="text-muted-foreground italic">No image configured</div>;
  }

  return (
    <>
      {field.placeholder && <div>Placeholder: {field.placeholder}</div>}
      {field.knowledge_name && (
        <div>Using knowledge: {field.knowledge_name}</div>
      )}
      {field.options && (
        <div>
          Options: {Array.isArray(field.options) 
            ? field.options.join(', ')
            : Object.values(field.options).join(', ')
          }
        </div>
      )}
    </>
  );
};
